// import QRCode from 'qrcode';

// const generateQRCode = async (url: string): Promise<string> => {
//     try {
//         const qrCodeDataUrl = await QRCode.toDataURL(url);
//         return qrCodeDataUrl;
//     } catch (error) {
//         if (error instanceof Error) {
//             throw new Error('Failed to generate QR code: ' + error.message);
//         } else {
//             throw new Error('Failed to generate QR code: Unknown error');
//         }
//     }
// };

// export default generateQRCode;
import QRCode from 'qrcode';

const generateQRCode = async (url: string): Promise<string> => {
    try {
        // Create a canvas element
        const canvas = document.createElement('canvas');
        // const ctx = canvas.getContext('2d');

        // Generate the QR code on the canvas
        await QRCode.toCanvas(canvas, url, { width: 300 });

        // // Add watermark text
        // if (ctx) {
        //     ctx.font = '16px Arial';
        //     ctx.fillStyle = '#888';
        //     ctx.textAlign = 'center';
        //     ctx.fillText('Generated by MT', canvas.width / 2, canvas.height - 10);
        // }

        // Convert the canvas to a data URL
        return canvas.toDataURL('image/png');
    } catch (error) {
        if (error instanceof Error) {
            throw new Error('Failed to generate QR code: ' + error.message);
        } else {
            throw new Error('Failed to generate QR code: Unknown error');
        }
    }
};

export default generateQRCode;